/**
 * Article Content Component
 * Converts paragraph tags containing only "---" into <hr> elements
 */

export class ArticleContent {
  private content: HTMLElement;

  constructor(contentElement: HTMLElement) {
    this.content = contentElement;
    this.init();
  }

  private init(): void {
    this.convertHorizontalRules();
  }

  private convertHorizontalRules(): void {
    // Find all paragraph tags
    const paragraphs = this.content.querySelectorAll('p');

    paragraphs.forEach((p) => {
      // Get text content, removing all whitespace
      const text = p.textContent?.trim() || '';

      // Check if the paragraph contains only "---"
      if (text === '---') {
        // Create an hr element
        const hr = document.createElement('hr');

        // Replace the paragraph with the hr
        p.replaceWith(hr);
      }
    });
  }
}
